import { render, staticRenderFns } from "./PositioningAddress.vue?vue&type=template&id=952c3de4&scoped=true&"
import script from "./PositioningAddress.vue?vue&type=script&lang=js&"
export * from "./PositioningAddress.vue?vue&type=script&lang=js&"
import style0 from "./PositioningAddress.vue?vue&type=style&index=0&id=952c3de4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952c3de4",
  null
  
)

export default component.exports